import axios from 'axios';
import { rteUrl } from '../Infrastructure/Config/ApiConfig';

const controllerName = 'Certificate';

// Public - certificate/badge details for a completed course, by learner-course (tracking) id.
// Returns null when there's no certificate (course not complete or not found).
export const getCertificateAsync = async (learnerCourseId) => {
    try {
        const response = await axios.get(`${rteUrl()}${controllerName}/${learnerCourseId}`);
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            return null;
        }
        throw err;
    }
}
